module.exports = __webpack_public_path__ + "img/dining-table.b339c96c.png";